import importscript from "../../../swgfl/javascript/import-script.js";

export default (node, key) => {
	window.hashRecaptchaCallback = () => {
		grecaptcha.render(node, {
			"sitekey": key
		});
	};
	importscript("https://www.google.com/recaptcha/api.js?render=explicit&onload=hashRecaptchaCallback");
};